<template src="./BottomPanel.html"></template>

<script>
import { Plotly } from "vue-plotly";
import { mapState } from "vuex";
import moment from 'moment';

export default {
  name: "BottomPanel",
  components: {
    Plotly,
  },
  computed: {

    ...mapState({
      mapLatLon: (state) => state.mapLatLon,
      pixelData: (state) => state.pixelData,
      pixelStats: (state) => state.pixelStats,
      all5Years: (state) => state.all5Years,
      menuVariable: (state) => state.menuVariable,
    }),

    // ...mapActions({
    //   getPixelStats: (actions) => state.getPixelStats,
    //   getChartData: (actions) => state.getChartData
    // }),

    getCoords: function () {
      return this.mapLatLon;
    },

    getCurrentPixelStats: function() {
      
      if (this.pixelData.length == 0)
        return []
      else {
        console.log('getCurrentPixelStats - this.pixelData: ', this.pixelData)
        let arr = [];
        let id = 0;
        this.pixelData.forEach(element => {
          console.log('---', {
            variable: element.name,
            min: Math.min.apply(Math, element.y),
            max: Math.max.apply(Math, element.y),
            mean: element.y.reduce((a, b) => (a + b)) / element.y.length,
            sum: element.y.reduce((sum, value) => sum + value, 0)
          })
          arr.push({
            variable: element.name,
            id: id++,
            min: Math.min.apply(Math, element.y),
            max: Math.max.apply(Math, element.y),
            mean: element.y.reduce((a, b) => (a + b)) / element.y.length,
            sum: element.y.reduce((sum, value) => sum + value, 0)
          });
        });
        return arr;
      }
    },

    getPixelStats: function() {
      return this.pixelStats;
    },

    isShowAggregationMethod: function() {
      return this.getVariableConfig(this.menuVariable.id) == undefined ? '' : this.getVariableConfig(this.menuVariable.id).isShowAccumulate;
    },

    getChartAnomalyData: function() {
      // Calculate anomaly
    
      if (this.pixelData.length < 1) return []

      // Calc average
      let average = this.pixelData[0].y.reduce((a, b) => a + b) / this.pixelData[0].y.length;
      
      return [{
        x: this.pixelData[0].x,
        y: this.pixelData[0].y.map((a) => a - average),
        type: 'bar',
        name: 'Deviation',
        marker: {
          color: this.pixelData[0].y.map((a) => (a - average) < 0 ? 'red' : 'blue')
        }
      }];

    },

    getChartData: function () {



      //let index = 0;
      
      //let average = [];
      //let somaAverage = [];

      // if (this.menuVariable.id != 'chill') {
      //   if (this.all5Years.length < 5) return [];
        
      //   let aux = 0;
      //   this.all5Years[0].y.forEach(value => {
      //     let s = value;
      //     [1,2,3,4].forEach(i => {
      //       s += this.all5Years[i].y[index];
      //     });
      //     average.push(s / 5);
      //     aux = aux + (s / 5);
      //     somaAverage.push(aux);
      //     index += 1;
      //   });
      // }

      // if (this.chartMethod == 'Accumulated') {
        
      //   let soma = []
      //   let aux = 0;
      //   this.pixelData.y.forEach(element => {
      //     aux += element;
      //     soma.push(aux);
      //   });
      //   return [{
      //     x: this.pixelData.x,
      //     y: soma,
      //     type: this.selectedTypeChart,
      //     name: "Pixel value"
      //   }, {
      //     x: this.pixelData.x,
      //     y: somaAverage,
      //     type: "scatter",
      //     name: "5 Years Average"
      //   }]
      // }

      //if (this.menuVariable.id == 'totR' || this.menuVariable.id == 'gdd') {
        
        let chart = [];
        let i = 1;
        this.pixelData.forEach(element => {

          if (this.chartMethod == 'Accumulated' && !this.getVariableConfig(element.name).isShowAccumulate)
            return;

          let chartConfig = this.getVariableConfig(element.name);
          let count = this.pixelData.filter((a) => a.name == element.name);
          let section = chart.filter((a) => this.getVariableConfig(a.variable).scale == chartConfig.scale )

          let yAxis = []
          if (this.chartMethod == 'Accumulated' && this.getVariableConfig(element.name).isShowAccumulate)
            element.y.reduce((a, b, i) => {return yAxis[i] = a + b}, 0)
          else
            yAxis = element.y

          chart.push({
            x: element.x,
            y: yAxis, //element.y, //element.y.reduce((total, a) => {return total + a}, 0),
            type: ((count.length > 1) && (chart.length > 0)) || (this.chartMethod == 'Accumulated') ? 'scatter' :  this.selectedTab == 1 ? 'bar' : chartConfig.chart.default,
            yaxis: section.length > 0 ? '' : ('y' + i++),
            name: chartConfig.description,
            variable: element.name,
            //marker: chartConfig.chart.line,
          });
          // if (i > 1) {
          //   this.layout[('yaxis'+i)].title = element.name;
          // }
        
          // i+=1;
        });

        if (this.selectedCompareWith.find(e => e == '5years'))
        this.all5Years.forEach(element => {

          let chartConfig = this.getVariableConfig(element.name);
          //let count = this.pixelData.filter((a) => a.name == element.name);
          let section = chart.filter((a) => this.getVariableConfig(a.variable).scale == chartConfig.scale )

          let yAxis = []
          if (this.chartMethod == 'Accumulated' && this.getVariableConfig(element.name).isShowAccumulate) 
            element.y.reduce((a, b, i) => {return yAxis[i] = a + b}, 0)
          else
            yAxis = element.y

          chart.push({
            x: this.pixelData[0].x,
            y: yAxis,//element.y,
            type: 'scatter',
            yaxis: section.length > 0 ? '' : ('y' + i),
            name: chartConfig.description + ' Long term avg',
            variable: element.name,
            //marker: chartConfig.chart.line,
          });
          //i+=1;
        });

        return chart;
    },

    fromDateDisp1() {
      return this.fromDateVal1;
    },
    fromDateDisp2() {
      return this.fromDateVal2;
    },
  },

  data: () => ({

    selectedTab: null,
    
    layout: {
      showlegend: true,
      autosize: true,
      //width: 1380,
      //height: 400,
      legend: {
        orientation: "h",
        yanchor: "bottom",
        xanchor: "center",
        y: -0.5,
        x: 0.5,
      },
      margin: {
        l: 50,
        r: 50,
        b: 0,
        t: 0,
        pad: 4,
      },
      xaxis: {
        tickangle: 40,
        showticklabels: true,
        type: 'scatter',
        //categoryorder: "category ascending",
        title: "Date",
      },
      yaxis: {
        title: "",
      },
      yaxis2: {
        title: '',
        overlaying: 'y',
        anchor: 'x',
        side: 'right'
      },
      yaxis3: {
        title: '',
        overlaying: 'y',
        anchor: 'free',
        side: 'right'
      },
      yaxis4: {
        title: '',
        overlaying: 'y',
        anchor: 'x',
        side: 'right'
      },
    },

    fromDateMenu: false,
    fromDateVal1: "2020-01-01",
    fromDateVal2: "2020-04-23",
    minDate: "1982-01-01",
    maxDate: "2021-07-12",//new Date().getDate()-2,
    threshold: 50,
    

    // 
    chartMethod: 'Daily',
    selectOptions: [{id: 1, description: 'Daily'}, {id: 2, description: 'Accumulated'}],
    
    chartAggregationMethodHint: '',
    chartAggregationMethod: {id: '1D', description: 'Daily'},
    aggregationPeriod: [{id: '1D', description: 'Daily'}, {id: '7D', description: 'Weekly'}, {id: '1M', description: 'Monthly'}, {id: '1Y', description: 'Yearly'}, {id: 'flexible', description: 'Flexible'}],

    //
    selectedCompareWith: [],
    optionsCompareWith: [{id: '5years', description: 'Historical Average'}, {id: '2021', description: '2021'}, {id: '2020', description: '2020'}, {id: '2019', description: '2019'}, {id: '2018', description: '2018'}, {id: '2017', description: '2017'}, {id: '2016', description: '2016'}],

    // selectedOtherVariables
    selectedMultipleVariables: [],
    optionsMultipleVariables: [{id: 'totR', description: 'Rainfall'}, {id: 'minT', description: 'Minimum Temperature'}, {id: 'maxT', description: 'Maximum Temperature'}, {id: 'avgT', description: 'Average Temperature'}, {id: 'chill-accumulation', description: 'Chill Hours (32°F - 45°F)'} , {id: 'gdd', description: 'Growing Degree Days'}],

  }),
  methods: {

    getVariableInfo: function(variable) {
      return this.getVariableConfig(variable) == undefined ? {description: ''} : this.getVariableConfig(variable);
    },


    onLoadData: function() {

      if (this.chartAggregationMethod.id == 'flexible') {
        this.chartAggregationMethodHint = "Please enter the number of days you want to aggregate";
        this.chartAggregationMethod.description = "... Days";
        return;
      } else {
        this.chartAggregationMethodHint = "";
      }

      // Check if is selected multiple variables
      let dts1 = []
      let dts2 = []
      if (this.selectedTab == 1) {

        dts1.push('1982-' + this.fromDateVal2.split('-')[1] + '-' + this.fromDateVal2.split('-')[2]);
        dts2.push('2021-' + this.fromDateVal2.split('-')[1] + '-' + this.fromDateVal2.split('-')[2]);

      } else {

        if (this.selectedCompareWith.length <= 1) {

          dts1.push(this.fromDateVal1);
          dts2.push(this.fromDateVal2);
          this.selectedCompareWith = [];
          this.selectedCompareWith.push(this.fromDateVal1.split('-')[0]);

        } else {
          

          if (this.selectedCompareWith.filter((e) => e == '5years').length > 0) {
            // get 5 years avg
            this.$store.dispatch("getHisAvg", {
              position: this.mapLatLon,
              sdate: this.fromDateVal1,
              edate: this.fromDateVal2,
              //sdate: this.fromDateVal1,
              //edate: this.fromDateVal2,
              agg: this.chartAggregationMethod.id,
              extraVariables: this.selectedMultipleVariables
            });
          }

          this.selectedCompareWith.forEach((year) => {
            if (year == '5years') return;
            let diff = ( moment(this.fromDateVal2).format('Y') - moment(this.fromDateVal1).format('Y') );
            dts1.push(year.split('-')[0] + '-' + this.fromDateVal1.split('-')[1] + '-' + this.fromDateVal1.split('-')[2])
            dts2.push((parseInt(year.split('-')[0]) + diff) +  '-' + this.fromDateVal2.split('-')[1] + '-' + this.fromDateVal2.split('-')[2])
          });
        
        }

      }

      if (this.selectedTab == 1 && this.selectedMultipleVariables.length > 1) {
        this.selectedMultipleVariables = []
        this.selectedMultipleVariables.push(this.menuVariable.id)
      }

      if (this.selectedTab == 1 && this.selectedCompareWith.length > 1) {
        this.selectedCompareWith = this.selectedCompareWith[0]
      }
      
      if (this.selectedMultipleVariables.length == 0)
        this.selectedMultipleVariables.push(this.menuVariable.id)

      if (this.selectedMultipleVariables.find(element => element == this.menuVariable.id) == undefined) {
        this.selectedMultipleVariables = []
        this.selectedMultipleVariables.push(this.menuVariable.id)
      }
      
      if (typeof this.chartAggregationMethod != 'object') {
        this.chartAggregationMethod = this.chartAggregationMethod.replace(/\D/g, "");
        this.chartAggregationMethod = {id: this.chartAggregationMethod + 'D', description: this.chartAggregationMethod + ' Days'}
      }

      if (this.chartMethod == 'Accumulated' && this.getVariableConfig(this.menuVariable.id).isShowAccumulate == false) {
        this.chartMethod = 'Daily';
      }

      if (this.menuVariable.id != 'chill-accumulation')
      this.$store.dispatch("getPixelStats", {
        position: this.mapLatLon,
        sdate: this.fromDateVal1,
        edate: this.fromDateVal2,
        agg: this.chartAggregationMethod.id,
        extraVariables: this.selectedMultipleVariables,
        threshold: this.threshold
      });

      this.$store.dispatch("getPixelData", {
          position: this.mapLatLon,
          sdate: dts1,
          edate: dts2,
          agg: this.selectedTab == 1 ? 'reduce' : this.chartAggregationMethod.id,
          extraVariables: this.selectedMultipleVariables,
          threshold: this.threshold
        });
    },

    getVariableConfig: function(variable) {
      let v = {
        'totR': {
          round: 2,
          isShowAccumulate: true,
          operation: 'sum',
          description: 'Total Precipitation (in)',
          scale: 'rainfall',
          chart: {
            default: 'bar',
            line: {
              color: '#1FA099',
              width: 3
            }
          }
        },
        'minT': {
          round: 1,
          isShowAccumulate: false,
          description: 'Minimum Temperature (°F)',
          scale: 'temperature',
          operation: 'mean',
          chart: {
            default: 'scatter',
            line: {
              color: '#08A5C2',
              width: 3
            }
          }
        },
        'maxT': {
          round: 1,
          isShowAccumulate: false,
          description: 'Maximum Temperature (°F)',
          scale: 'temperature',
          operation: 'mean',
          chart: {
            default: 'scatter',
            line: {
              color: '#F26726',
              width: 3
            }
          }
        },
        'avgT': {
          round: 1,
          isShowAccumulate: false,
          description: 'Average Temperature (°F)',
          scale: 'temperature',
          operation: 'mean',
          chart: {
            default: 'scatter',
            line: {
              color: '#F26726',
              width: 3
            }
          }
        },
        'gdd': {
          round: 1,
          isShowAccumulate: true,
          description: 'Growing Degree Days',
          scale: 'rainfall',
          operation: 'sum',
          chart: {
            default: 'bar',
            line: {
              color: '#F26726',
              width: 3
            }
          }
        },
        'chill-accumulation': {
          round: 1,
          isShowAccumulate: true,
          description: 'Chill Hours (32°F - 45°F)',
          scale: 'rainfall',
          operation: 'sum',
          chart: {
            default: 'bar',
            line: {
              color: '#F26726',
              width: 3
            }
          }
        }
      }
      return v[variable]
    }


  },
};
</script>


<style lang="scss" src="./BottomPanel.scss">
</style>